import { OnboardingWrapper } from '@seedlang/hoc';
import { AppUI } from '@seedlang/state';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import { observer } from 'mobx-react';
import React from 'react';
import OnboardingSeedlang from './onboarding_seedlang';
import OnboardingMemrev from './onboarding_memrev';
import withRouteParams from 'utils/with_route_params';

@observer
class Onboarding extends React.Component {

  render() {
    return (
      AppUI.siteIsSeedlang ? (
        <OnboardingSeedlang {...this.props} />
      ) : (
        <OnboardingMemrev {...this.props} />
      )
    );
  }
}

export default withRouteParams(ErrorBoundary(OnboardingWrapper(Onboarding)));
